const state = {
  user: {},
  // 插件端的userToken
  userToken: null,
  showUserDetail: false
}
const getters = {
  user: (state) => { return state.user },
  userToken: (state) => { return state.userToken },
  showUserDetail: (state) => { return state.showUserDetail }
}
const mutations = {
  setUser(state, data) {
    state.user = data
  },
  setUserToken(state, data) {
    state.userToken = data
  },
  setShowUserDetail(state, value) {
    state.showUserDetail = value
  }
}
const actions = {
  // 获取用户信息
  async loadUserInfo({ commit }, headers = {}) {
    try {
      const res = await this.$api.user.getUserInfo(headers)
      commit('setUser', res || {})
    } catch (error) {
      commit('setUser', {})
    }
  },
  // 退出登录
  async logoutPlugin({ commit }, payload) {
    try {
      const { token } = payload
      await this.$api.user.logoutPlugin({ Authorization: `Bearer ${token}` })
      commit('setUser', {})
    } catch (error) {
      console.log('退出失败')
      const e = JSON.parse(error.message)
      this.tip = e.message
    }
  },
  // 退出登录
  async logout({ commit }, { dest }) {
    try {
      // 先校验用户是否还在登录态
      const res = await this.$api.user.getUserInfo()
      if (res) {
        window.location = await this.$api.user.logout(dest)
        commit('setUser', {})
      } else {
        commit('setUser', {})
      }
    } catch (error) {
      console.log('退出失败')
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
